import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

interface SidebarButtonBaseProps {
  icon: ReactNode;
  title: string;
  isActive?: boolean;
}

interface SidebarButtonButtonProps extends SidebarButtonBaseProps {
  type: "button";
  onClick: () => void;
}

interface SidebarButtonLinkProps extends SidebarButtonBaseProps {
  type: "link";
  href: string;
}

export type LiveChatUISidebarButtonProps =
  | SidebarButtonButtonProps
  | SidebarButtonLinkProps;

const BASE_CLASS = cx(
  "flex w-full items-center gap-1.5 rounded-[10px] px-3 h-10 shrink-0 transition-colors",
  "font-secondary text-sm font-normal leading-[140%]"
);

const ACTIVE_CLASS = "bg-grey-100 text-black";
const INACTIVE_CLASS =
  "hover:bg-grey-100 hover:text-black bg-transparent text-[#4F4F4F]";

export const LiveChatUISidebarButton: FC<LiveChatUISidebarButtonProps> = ({
  icon,
  title,
  isActive,
  ...props
}) => {
  const innerContent = (
    <>
      <span className="shrink-0 leading-0">{icon}</span>
      <span className="truncate">{title}</span>
    </>
  );

  const itemClassName = cx(
    BASE_CLASS,
    isActive ? ACTIVE_CLASS : INACTIVE_CLASS
  );

  if (props.type === "link") {
    return (
      <a
        href={props.href}
        target="_blank"
        rel="noopener noreferrer"
        className={cx("no-underline", itemClassName)}
      >
        {innerContent}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={cx("cursor-pointer border-none bg-transparent", itemClassName)}
      onClick={props.onClick}
    >
      {innerContent}
    </button>
  );
};
